"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdkData = exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var gridCalculations_1 = require("../../core/galleriesCommon/gridCalculations");
var constants_1 = require("../../core/constants");
var MIN_HEIGHT = 70;
exports.props = withCompInfo_1.withCompInfo(['skin', 'compProps'], function (_a, carmiData) {
    var skin = _a.skin, compProps = _a.compProps;
    var rows = compProps.maxRows, columns = compProps.numCols, galleryImageOnClickAction = compProps.galleryImageOnClickAction, autoPlay = compProps.autoplay, showNavigation = compProps.showNavigation, showAutoplay = compProps.showAutoplay, showCounter = compProps.showCounter, goToLinkText = compProps.goToLinkText;
    var hasTransition = compProps.transition !== 'none';
    var transition = constants_1.legacyTransitionTypesMap[compProps.transition] || 'NoTransition';
    var transitionDuration = compProps.transDuration * 1000;
    var autoPlayInterval = compProps.autoplayInterval * 1000 +
        (hasTransition ? transitionDuration : 0);
    return {
        skin: skin,
        rows: rows,
        columns: columns,
        items: carmiData.itemsProps,
        imageOnClickAction: galleryImageOnClickAction,
        transition: transition,
        transitionDuration: transitionDuration,
        autoPlay: autoPlay,
        autoPlayInterval: autoPlayInterval,
        showNavigation: showNavigation,
        showAutoplay: showAutoplay,
        showCounter: showCounter,
        reducedMotion: false,
        currentPage: 0,
        goToLinkText: goToLinkText || 'Go to link',
    };
});
var skinBottomPaddingMap = {
    PaginatedGridDefaultSkin: 0,
    PaginatedGridOverlay: 0,
    PaginatedGridArrowsOutside: 20,
    PaginatedGridRibbonArrows: 20,
    PaginatedGridTextBottom: 60,
};
exports.css = withCompInfo_1.withCompInfo(['skin', 'compProps', 'compLayout'], function (_a, carmiCss) {
    var skin = _a.skin, compProps = _a.compProps, compLayout = _a.compLayout;
    var _b = compLayout.height, height = _b === void 0 ? MIN_HEIGHT : _b;
    var margin = compProps.margin, rows = compProps.maxRows, columns = compProps.numCols, transDuration = compProps.transDuration;
    var galleryBottomPadding = skinBottomPaddingMap[skin];
    var rowHeight = gridCalculations_1.getRowHeight(height, margin, rows, galleryBottomPadding);
    var galleryWidthRelativeToItem = "calc(100% * " + columns + " + var(--spacing) * " + columns + ")";
    var galleryHeightRelativeToItem = "calc(100% * " + rows + " + var(--spacing) * " + rows + ")";
    return __assign(__assign({}, carmiCss), { '--number-of-columns': columns, '--spacing': margin + "px", '--row-height': rowHeight + "px", '--transition-duration': transDuration * 1000 + "ms", '--horiz-translate-item-pct': galleryWidthRelativeToItem, '--vert-translate-item-pct': galleryHeightRelativeToItem, '--gallery-bottom-padding': galleryBottomPadding + "px" });
});
exports.sdkData = withCompInfo_1.withCompInfo(['compData'], function (_a) {
    var compData = _a.compData;
    return {
        imageDisplayMode: 'fill',
        dataId: compData.id,
    };
});
//# sourceMappingURL=PaginatedGridGallery.js.map